import { render, staticRenderFns } from "./SchedulingDashboard.vue?vue&type=template&id=c0a85212"
import script from "./SchedulingDashboard.vue?vue&type=script&lang=js"
export * from "./SchedulingDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports